import { createReducer, on, Action } from '@ngrx/store';
import { DataExportActions } from './data-export.actions';

export interface State {
  loading: boolean;
  error: any;
}

export const INITIAL_STATE: State = {
  loading: false,
  error: null,
};

const dataExportReducer = createReducer(
  INITIAL_STATE,
  on(DataExportActions.requestExportFeedback, (state) => ({
    ...state,
    loading: true,
  })),
  on(DataExportActions.requestExportCustomersStatistics, (state) => ({
    ...state,
    loading: true,
  })),
  on(DataExportActions.requestExportMembersStatistics, (state) => ({
    ...state,
    loading: true,
  })),
  on(DataExportActions.requestExportQuestionAnswers, (state) => ({
    ...state,
    loading: true,
  })),
  on(DataExportActions.requestExportCustomersStatisticsForOrganisations, (state) => ({
    ...state,
    loading: true,
  })),
  on(DataExportActions.requestExportMembersStatisticsForOrganisations, (state) => ({
    ...state,
    loading: true,
  })),
  on(DataExportActions.requestExportContentStatisticsForOrganisations, (state) => ({
    ...state,
    loading: true,
  })),
  on(DataExportActions.requestExportFeedbackForOrganisations, (state) => ({
    ...state,
    loading: true,
  })),
  on(DataExportActions.exportCheckInsForCustomer, (state) => ({
    ...state,
    loading: true,
  })),
  on(DataExportActions.exportRecentComments, (state) => ({
    ...state,
    loading: true,
  })),
  on(DataExportActions.successSaveFile, (state) => ({ ...state, loading: false })),
  on(DataExportActions.responseFailDataExport, (state, action) => ({
    ...state,
    loading: false,
    error: action.error,
  })),
);

export function reducer(state: State | undefined, action: Action) {
  return dataExportReducer(state, action);
}
